import { TFunction } from 'i18next'
import { equals, path } from 'ramda'

import { useToast } from '@surglogs-app/ui.toast'

import { useHandler } from '../../../hooks/src'
import { useAccountSettingsTranslation } from '../services'

const getToastText = (error: unknown, t: TFunction<any>) => {
  const remainingTime = (path(
    ['response', 'data', 'error_details', 'remaining_time'],
    error,
  ) || 0) as number

  const errorCode = path(
    ['response', 'data', 'error_code'],
    error || {},
  ) as string

  if (equals(errorCode, 'incorrect_login')) {
    const isLessThanMinute = remainingTime < 60
    const time = isLessThanMinute
      ? remainingTime
      : Math.floor(remainingTime / 60)
    const unit = isLessThanMinute
      ? t('second', { count: time })
      : t('minute', { count: time })

    return `${t(errorCode as any)} ${time} ${unit}.`
  }

  if (equals(errorCode, 'invalid_request')) {
    return path(['response', 'data', 'error_message'], error) as string
  }

  return t([errorCode, 'unspecifiedError'] as any)
}

export const useAccountPasswordUpdateFailureAlert = () => {
  const { showErrorToast } = useToast()
  const { t } = useAccountSettingsTranslation()

  const showAccountPasswordUpdateFailureAlert = useHandler(
    ({ error }: { error: unknown }) => {
      showErrorToast({
        title: t('updateFailed'),
        text: getToastText(error, t),
      })
    },
  )

  return { showAccountPasswordUpdateFailureAlert }
}
